<template>
    <div class="my-2">
        <div class="w-full flex justify-center mb-3">
            <span class="text-theme-primary">
                Días transcurridos {{ daysAgo }}
            </span>
        </div>
        <DateRangePicker
            v-model="dateRange"
            :allow-future-dates="false"
            :show-days-count="false"
            :default-range="1"
            @change="handleDateChange"
        />
    </div>
</template>

<script>
import { DateTime } from "luxon";
import { mapGetters, mapState } from "vuex";

import DateRangePicker from "./DateRangePicker.vue";

export default {
    name: "DatesRangeFilter",
    components: {
        DateRangePicker
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Object,
            required: false,
            default: () => ({
                end: DateTime.now().toFormat("yyyy-MM-dd"),
                begin: DateTime.now().plus({ days: -1 }).toFormat("yyyy-MM-dd")
            })
        },
        dateMax: {
            type: String,
            required: false,
            default: DateTime.now().toFormat("yyyy-MM-dd")
        }
    },
    data: () => ({
        dateRange: {
            end: DateTime.now().toFormat("yyyy-MM-dd"),
            begin: DateTime.now().plus({ days: -1 }).toFormat("yyyy-MM-dd")
        },
        daysAgo: 1
    }),
    computed: {
        ...mapState("control", ["activeDark"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {
        itemsCurrent: {
            handler(value) {
                if (value && Object.keys(value).length > 0) {
                    this.dateRange = {
                        begin: value.begin,
                        end: value.end
                    };
                    this.calculateDaysAgo();
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        if (!this.itemsCurrent || Object.keys(this.itemsCurrent).length === 0) {
            this.dateRange = {
                end: DateTime.now().toFormat("yyyy-MM-dd"),
                begin: DateTime.now().plus({ days: -1 }).toFormat("yyyy-MM-dd")
            };
            this.calculateDaysAgo();
        }
    },
    methods: {
        handleDateChange(value) {
            const dtBegin = DateTime.fromISO(value.begin);
            const dtEnd = DateTime.fromISO(value.end);

            if (dtBegin > dtEnd) {
                this.$swal({
                    background: this.backgroundColor,
                    icon: "error",
                    title: "Rango no permitido",
                    text: "La fecha inicial no puede ser posterior a la fecha final.",
                    confirmButtonColor: "#3085d6"
                });

                this.dateRange = {
                    begin: dtEnd.minus({ days: 1 }).toFormat("yyyy-MM-dd"),
                    end: value.end
                };
                return;
            }

            this.dateRange = value;
            this.calculateDaysAgo();

            this.$emit("change", {
                begin: value.begin,
                end: value.end
            });
        },
        calculateDaysAgo() {
            if (!this.dateRange.begin || !this.dateRange.end) {
                this.daysAgo = 0;
                return;
            }

            this.daysAgo = Math.floor(
                DateTime.fromISO(this.dateRange.end).diff(
                    DateTime.fromISO(this.dateRange.begin),
                    "days"
                ).days
            );
        }
    }
};
</script>
